import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, unref as _unref, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, withKeys as _withKeys, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-370a79d3"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d-flex flex-wrap justify-center align-center ga-1 mb-2" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-caption text-medium-emphasis mr-1" }, "contra", -1))
const _hoisted_3 = {
  key: 1,
  class: "text-center py-6"
}
const _hoisted_4 = {
  key: 2,
  class: "text-body-2 text-error text-center"
}
const _hoisted_5 = { class: "text-subtitle-1 font-weight-bold mb-1" }
const _hoisted_6 = {
  key: 0,
  class: "text-body-2 text-medium-emphasis"
}
const _hoisted_7 = {
  class: "reparto mb-1",
  "aria-hidden": "true"
}
const _hoisted_8 = { class: "text-body-2 mb-1" }
const _hoisted_9 = { class: "text-body-2 mb-1" }
const _hoisted_10 = {
  key: 0,
  class: "text-caption text-medium-emphasis mb-1"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "text-subtitle-2 font-weight-bold mt-3 mb-1" }, " Según los puntos ", -1))
const _hoisted_12 = { class: "text-medium-emphasis" }
const _hoisted_13 = { class: "text-right" }
const _hoisted_14 = { class: "text-right text-caption text-medium-emphasis" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "text-subtitle-2 font-weight-bold mt-3 mb-1" }, "Partidas", -1))
const _hoisted_16 = ["role", "tabindex", "onClick", "onKeydown"]
const _hoisted_17 = { class: "text-caption text-medium-emphasis" }
const _hoisted_18 = { class: "text-body-2 d-flex align-center ga-2" }
const _hoisted_19 = { class: "lado" }
const _hoisted_20 = {
  key: 0,
  class: "text-medium-emphasis"
}
const _hoisted_21 = { class: "lado text-right" }
const _hoisted_22 = {
  key: 1,
  class: "text-caption text-medium-emphasis mt-1 mb-0"
}
const _hoisted_23 = /*#__PURE__*/_createStaticVNode("<h3 class=\"text-subtitle-2 font-weight-bold mb-1\" data-v-370a79d3>Los más jugados</h3><div class=\"cabecera-cruces text-caption text-medium-emphasis\" data-v-370a79d3><span data-v-370a79d3>Cruce</span><span class=\"text-right\" data-v-370a79d3>Part.</span><span class=\"text-right\" data-v-370a79d3>% vict.</span><span class=\"text-right\" data-v-370a79d3>Rinde</span></div>", 2)
const _hoisted_25 = /*#__PURE__*/_createStaticVNode("<h3 class=\"text-subtitle-2 font-weight-bold mt-4 mb-1\" data-v-370a79d3> Los más desequilibrados </h3><div class=\"cabecera-cruces text-caption text-medium-emphasis\" data-v-370a79d3><span data-v-370a79d3>Cruce</span><span class=\"text-right\" data-v-370a79d3>Part.</span><span class=\"text-right\" data-v-370a79d3>% vict.</span><span class=\"text-right\" data-v-370a79d3>Rinde</span></div>", 2)

import { computed, onMounted, ref, watch } from "vue";
import { useRouter } from "vue-router";
import type {
  Bando,
  CruceEjercitosDTO,
  CrucesDestacadosDTO,
  FiltroEstadisticas,
  PartidaCruceDTO,
} from "@/interfaces/Estadisticas";
import {
  getCruce,
  getCrucesDestacados,
  getRankingEjercitos,
} from "@/services/EstadisticasService";
import { mensajeDelBack } from "@/utils/mensajeDelBack";
import { formatFechaSpaWhitoutAsync } from "@/utils/Fecha";
import {
  colorRinde,
  textoBando,
  textoDecimal,
  textoPorcentaje,
  textoRinde,
  textoTramo,
} from "@/utils/estadisticasEjercitos";
import FilaCruce from "./FilaCruce.vue";

const POCAS_PARTIDAS_CRUCE = 10;
const MINIMO_DESEQUILIBRADO = 10;


export default /*#__PURE__*/_defineComponent({
  __name: 'CrucesEjercitos',
  props: {
    filtro: {},
    inicial: {}
  },
  setup(__props: any) {

const props = __props;

const router = useRouter();
const nombres = ref<string[]>([]);
const ejercito = ref<string | null>(props.inicial?.ejercito ?? null);
const contra = ref<"ejercito" | Bando>("ejercito");
const rival = ref<string | null>(props.inicial?.rival ?? null);
const cruce = ref<CruceEjercitosDTO | null>(null);
const destacados = ref<CrucesDestacadosDTO | null>(null);
const cargando = ref(false);
const error = ref<string | null>(null);

// Todos los ejércitos que se han jugado alguna vez, por orden alfabético
onMounted(async () => {
  try {
    const todos = await getRankingEjercitos({ amistosas: true }, 1);
    nombres.value = todos
      .map(e => e.ejercito)
      .sort((a, b) => a.localeCompare(b, "es"));
  } catch (e) {
    console.error("Error al cargar los ejércitos:", e);
  }
});

watch(
  () => props.inicial,
  inicial => {
    if (!inicial) return;
    ejercito.value = inicial.ejercito;
    contra.value = "ejercito";
    rival.value = inicial.rival;
  }
);

const listo = computed(
  () => !!ejercito.value && (contra.value !== "ejercito" || !!rival.value)
);
const textoRival = computed(() =>
  contra.value === "ejercito"
    ? (cruce.value?.rival ?? "")
    : `todo el ${textoBando(contra.value)}`
);

const cargar = async () => {
  cargando.value = true;
  error.value = null;
  try {
    if (listo.value && ejercito.value) {
      destacados.value = null;
      cruce.value = await getCruce(
        ejercito.value,
        contra.value === "ejercito"
          ? { ejercito: rival.value }
          : { bando: contra.value },
        props.filtro
      );
    } else {
      cruce.value = null;
      destacados.value = await getCrucesDestacados(props.filtro);
    }
  } catch (e) {
    error.value = mensajeDelBack(
      e,
      "No se han podido cargar los cruces. Inténtalo de nuevo."
    );
  } finally {
    cargando.value = false;
  }
};
watch([ejercito, contra, rival, () => props.filtro], cargar, {
  deep: true,
  immediate: true,
});

const elegir = (elegido: { ejercito: string; rival: string }) => {
  ejercito.value = elegido.ejercito;
  contra.value = "ejercito";
  rival.value = elegido.rival;
};

const irAlEvento = (partida: PartidaCruceDTO) => {
  if (partida.idTorneo)
    router.push(`/detalle-evento/${partida.idTorneo}?tab=resultados`);
};

const colorResultado = (puntuacion: number) =>
  puntuacion === 1
    ? "text-success"
    : puntuacion === 0
      ? "text-error"
      : "text-medium-emphasis";

return (_ctx: any,_cache: any) => {
  const _component_v_autocomplete = _resolveComponent("v-autocomplete")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_progress_linear = _resolveComponent("v-progress-linear")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_v_autocomplete, {
      modelValue: ejercito.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((ejercito).value = $event)),
      items: nombres.value,
      placeholder: "Elige un ejército",
      "prepend-inner-icon": "mdi-shield",
      variant: "outlined",
      density: "compact",
      clearable: "",
      "hide-details": "",
      class: "mb-2"
    }, null, 8, ["modelValue", "items"]),
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createVNode(_component_v_chip, {
        size: "small",
        color: contra.value === 'ejercito' ? 'primary' : undefined,
        onClick: _cache[1] || (_cache[1] = ($event: any) => (contra.value = 'ejercito'))
      }, {
        default: _withCtx(() => [
          _createTextVNode(" Otro ejército ")
        ]),
        _: 1
      }, 8, ["color"]),
      _createVNode(_component_v_chip, {
        size: "small",
        color: contra.value === 'good' ? 'primary' : undefined,
        onClick: _cache[2] || (_cache[2] = ($event: any) => (contra.value = 'good'))
      }, {
        default: _withCtx(() => [
          _createTextVNode(" Todo el Bien ")
        ]),
        _: 1
      }, 8, ["color"]),
      _createVNode(_component_v_chip, {
        size: "small",
        color: contra.value === 'evil' ? 'primary' : undefined,
        onClick: _cache[3] || (_cache[3] = ($event: any) => (contra.value = 'evil'))
      }, {
        default: _withCtx(() => [
          _createTextVNode(" Todo el Mal ")
        ]),
        _: 1
      }, 8, ["color"])
    ]),
    (contra.value === 'ejercito')
      ? (_openBlock(), _createBlock(_component_v_autocomplete, {
          key: 0,
          modelValue: rival.value,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((rival).value = $event)),
          items: nombres.value,
          placeholder: "Elige el rival",
          "prepend-inner-icon": "mdi-shield-half-full",
          variant: "outlined",
          density: "compact",
          clearable: "",
          "hide-details": "",
          class: "mb-3"
        }, null, 8, ["modelValue", "items"]))
      : _createCommentVNode("", true),
    (cargando.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createVNode(_component_v_progress_circular, {
            indeterminate: "",
            color: "primary"
          })
        ]))
      : (error.value)
        ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(error.value), 1))
        : (cruce.value)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
              _createElementVNode("h3", _hoisted_5, _toDisplayString(cruce.value.ejercito) + " contra " + _toDisplayString(textoRival.value), 1),
              (cruce.value.resumen.partidas === 0)
                ? (_openBlock(), _createElementBlock("p", _hoisted_6, " Aún no se han enfrentado con estos filtros. "))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createElementVNode("div", _hoisted_7, [
                      _createElementVNode("div", {
                        style: _normalizeStyle({ flex: cruce.value.resumen.victorias }),
                        class: "bg-success"
                      }, null, 4),
                      _createElementVNode("div", {
                        style: _normalizeStyle({ flex: cruce.value.resumen.empates }),
                        class: "bg-grey"
                      }, null, 4),
                      _createElementVNode("div", {
                        style: _normalizeStyle({ flex: cruce.value.resumen.derrotas }),
                        class: "bg-error"
                      }, null, 4)
                    ]),
                    _createElementVNode("p", _hoisted_8, _toDisplayString(cruce.value.resumen.partidas) + " partidas · " + _toDisplayString(cruce.value.resumen.victorias) + " ganadas · " + _toDisplayString(cruce.value.resumen.empates) + " " + _toDisplayString(cruce.value.resumen.empates === 1 ? "empate" : "empates") + " · " + _toDisplayString(cruce.value.resumen.derrotas) + " perdidas ", 1),
                    _createElementVNode("p", _hoisted_9, [
                      _createTextVNode(_toDisplayString(_unref(textoPorcentaje)(cruce.value.resumen.porcentaje)) + " de victorias · ", 1),
                      _createElementVNode("span", {
                        class: _normalizeClass(_unref(colorRinde)(cruce.value.resumen.rinde))
                      }, _toDisplayString(_unref(textoRinde)(cruce.value.resumen.rinde)), 3),
                      _createTextVNode(" de «Rinde» · " + _toDisplayString(_unref(textoDecimal)(cruce.value.resumen.puntosFavor)) + " a " + _toDisplayString(_unref(textoDecimal)(cruce.value.resumen.puntosContra)) + " de media ", 1)
                    ]),
                    (cruce.value.resumen.partidas < POCAS_PARTIDAS_CRUCE)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_10, " Pocas partidas: tómalo con cautela. "))
                      : _createCommentVNode("", true),
                    _hoisted_11,
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(cruce.value.porTramo, (tramo) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: tramo.tramo,
                        class: "barra text-body-2"
                      }, [
                        _createElementVNode("span", _hoisted_12, _toDisplayString(_unref(textoTramo)(tramo.tramo)), 1),
                        _createVNode(_component_v_progress_linear, {
                          "model-value": tramo.partidas ? tramo.porcentaje : 0,
                          color: "primary",
                          "bg-color": "grey",
                          height: "8",
                          rounded: ""
                        }, null, 8, ["model-value"]),
                        _createElementVNode("span", _hoisted_13, _toDisplayString(tramo.partidas ? _unref(textoPorcentaje)(tramo.porcentaje) : "—"), 1),
                        _createElementVNode("span", _hoisted_14, _toDisplayString(tramo.partidas), 1)
                      ]))
                    }), 128)),
                    _hoisted_15,
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(cruce.value.partidas, (partida) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: `${partida.esAmistosa}-${partida.idPartida}`,
                        class: _normalizeClass(["partida", { pulsable: partida.idTorneo }]),
                        role: partida.idTorneo ? 'button' : undefined,
                        tabindex: partida.idTorneo ? 0 : undefined,
                        onClick: ($event: any) => (irAlEvento(partida)),
                        onKeydown: _withKeys(($event: any) => (irAlEvento(partida)), ["enter"])
                      }, [
                        _createElementVNode("div", _hoisted_17, [
                          _createTextVNode(_toDisplayString(_unref(formatFechaSpaWhitoutAsync)(partida.fecha)) + " · " + _toDisplayString(partida.esAmistosa ? "Amistosa" : partida.nombreTorneo) + " ", 1),
                          (partida.ronda)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _createTextVNode(" · ronda " + _toDisplayString(partida.ronda), 1)
                              ], 64))
                            : _createCommentVNode("", true),
                          (partida.puntos)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                _createTextVNode(" · " + _toDisplayString(partida.puntos) + " puntos", 1)
                              ], 64))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", _hoisted_18, [
                          _createElementVNode("span", _hoisted_19, [
                            _createTextVNode(_toDisplayString(partida.nick) + " ", 1),
                            (cruce.value.rival !== partida.ejercitoRival)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_20, " contra " + _toDisplayString(partida.ejercitoRival), 1))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("strong", {
                            class: _normalizeClass([colorResultado(partida.puntuacion), "flex-shrink-0"])
                          }, _toDisplayString(partida.resultado) + " - " + _toDisplayString(partida.resultadoRival), 3),
                          _createElementVNode("span", _hoisted_21, _toDisplayString(partida.nickRival), 1)
                        ])
                      ], 42, _hoisted_16))
                    }), 128)),
                    (cruce.value.partidas.length < cruce.value.resumen.partidas)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_22, " Las " + _toDisplayString(cruce.value.partidas.length) + " más recientes de " + _toDisplayString(cruce.value.resumen.partidas) + ". ", 1))
                      : _createCommentVNode("", true)
                  ], 64))
            ], 64))
          : (destacados.value)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                _hoisted_23,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(destacados.value.masJugados, (c) => {
                  return (_openBlock(), _createBlock(FilaCruce, {
                    key: `j-${c.ejercito}-${c.rival}`,
                    cruce: c,
                    onElegir: elegir
                  }, null, 8, ["cruce"]))
                }), 128)),
                _hoisted_25,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(destacados.value.masDesequilibrados, (c) => {
                  return (_openBlock(), _createBlock(FilaCruce, {
                    key: `d-${c.ejercito}-${c.rival}`,
                    cruce: c,
                    onElegir: elegir
                  }, null, 8, ["cruce"]))
                }), 128)),
                _createElementVNode("p", { class: "text-caption text-medium-emphasis mt-1 mb-0" }, " Con " + _toDisplayString(MINIMO_DESEQUILIBRADO) + " partidas o más, cada uno visto desde el ejército que se impone. ")
              ], 64))
            : _createCommentVNode("", true)
  ]))
}
}

})